        @file:Suppress("unused")
        package com.hyperether.resources
        
        object StringsDefault {
            val strings: Map<String, String> = mapOf(
"app_name" to "GoodJob",
"welcome" to "Welcome to GoodJob",
"onboarding_description1" to "Your go-to platform for managing tasks, tracking progress, and staying organized.",
"onboarding_description2" to "Create tasks, assign them to team members, and track their status. Manage everything from one place.",
"powerful_tools" to "Powerful Tools",
"next" to "Next",
"back" to "Back",
"skip" to "Skip",
"sign_in" to "Sign In",
"join_good_job" to "Join GoodJob!",
"sign_in_good_job" to "Sign in to GoodJob",
"start_organizing" to "Start organizing your team today",
"access_the_platform" to "Access the platform where managers assign tasks, and employees track and complete them—all in one place!",
"full_name" to "Full name",
"your_full_name" to "Your full name",
"email_address" to "Email address",
"email_address_mandatory" to "Email address *",
"your_email_address" to "Your email address",
"password" to "Password",
"repeat_password" to "Repeat password",
"your_password" to "Your password",
"register_with" to "or",
"register" to "Register",
"welcome_back" to "Welcome back!",
"forgot_password" to "Forgot password?",
"sign_in_with" to "or",
"manage_employees" to "Manage your employees, tasks, and schedule effortlessly",
"hello" to "Hello!",
"locations_agenda" to "locations on your agenda",
"locations_agenda_text" to "View scheduled job locations across the map for a clear overview of assigned tasks.",
"join_us" to "Join us today and get started!",
"effortless_efficiency" to "EFFORTLESS EFFICIENCY",
"transform" to "Transform How Your Team Works with GoodJob",
"optimize_your" to "Optimize your job management process with a solution designed for efficiency, collaboration, and scalability.",
"enter_your_email" to "Enter your email",
"continue_with_google" to "Continue with Google",
"continue_with_microsoft" to "Continue with Microsoft",
"continue_with_fb" to "Continue with Facebook",
"continue_with_apple" to "Continue with Apple",
"choose_the_right_plan" to "Choose the right plan for you",
"free" to "Free",
"month" to "/month",
"users" to "users",
"fast_track" to "Fast-track support within 8 hours",
"day_free_trial" to "7-Day Free Trial. Cancel Anytime.",
"built_for" to "Built for thriving teams, with features that elevate productivity effortlessly.",
"ready_for" to "Ready for another productive day?",
"already_have_an_account" to "Already have an account? ",
"need_an_account" to "Need an account? ",
"create_one" to "Create one",
"most_popular" to "MOST POPULAR",
"all_rights_reserved" to "2024 Mycomp IT-Services GmbH - www.mycomp.ch. All rights reserved.",
"privacy_policy" to "Privacy Policy",
"terms_of_service" to "Terms of Service",
"free_100" to "It's 100% free and we will never send more than one email per month",
"its" to "It's ",
"free_hundred" to "100% free",
"and_we_will" to " and we will never send more than one email per month",
"pricing" to "PRICING",
"transparent_flexible" to "Transparent, Flexible Pricing for Every Team Size",
"whether" to "Whether you're managing a small team or overseeing a large-scale operation, GoodJob offers flexible plans that grow with your business.",
"unlimited_storage" to "Unlimited storage",
"publish_key" to "pk_test_51QKL8eJYnILGHOmxNRipLB7zsIeMYqbPeLVtm17ZtZSrCCaTDG9yyByNosu6fhupi59rDbogvg1cbvyxM7e92KjH00eMjqJqTp",
"register_msg" to "Efficient solutions for employee and task management",
"subscribe" to "Subscribe",
"choose_plan" to "Choose Plan",
"contact_us" to "Contact us",
"login_register" to "Login/Register",
"user" to "User",
"support" to "Support within 8 hours",
"priority_support" to "Priority support within 8 hours",
"fast_track_support" to "Fast-track support within 8 hours",
"dedicated_support" to "Dedicated support within 8 hours",
"freebie_plan_description" to "Empower your team to start strong, with everything essential to get the job done.",
"high_five_plan_description" to "Perfect for growing teams, designed to help you scale without limits.",
"fly_high_plan_description" to "Built for thriving teams, with features that elevate productivity effortlessly.",
"galactic_plan_description" to "Tailored for enterprises, offering unmatched power and precision for your team.",
"dashboard" to "Dashboard",
"no_tasks_created" to "No tasks created",
"no_tasks_assigned" to "You haven’t assigned any tasks yet. Start by creating a task to keep your team moving forward.",
"check_soon" to "You don't have any tasks right now. Check back soon or connect with your manager for updates.",
"today_schedule" to "Today’s Schedule",
"jobs_overview" to "Jobs Overview",
"jobs_list" to "Jobs List",
"filter" to "Filter",
"personal_details" to "Personal details",
"choose_the_plan" to "Hello! Choose the plan that’s right for you!",
"from_small_teams" to "From small teams to large enterprises, we’ve got a plan that scales with you.\nPick the one that fits your goals and start optimizing your workflow today.",
"select_your_workspace" to "Select your workspace",
"select_role" to "Select role",
"choose_your_workspace" to "Choose a workspace to access your dashboard",
"access_dashboard" to "Access dashboard",
"create_workspace" to "Create a new workspace",
"new_workspace" to " New workspace",
"add_new_workspace" to "Add new workspace",
"role" to "Role",
"role_mandatory" to "Role *",
"last_accessed" to "Last Accessed: ",
"plan" to "Plan: ",
"set_up_workspace" to "Set up your workspace and get started with your dashboard.",
"workspace_name" to "Workspace name",
"enter_workspace_name" to "Enter the name of your workspace",
"create" to "Create",
"choose_category" to "Choose the category",
"already_have_workspace" to "Already have a workspace?",
"click_here" to "Click here to choose it",
"today" to "Today",
"add_new" to "Add new",
"add_new_job" to "Add new job",
"create_new_task" to "Plan and assign a new task to your team, complete with schedules and details.",
"create_new_employee" to "Expand your team by adding a new staff member with roles and skills.",
"add_new_employee" to "Add new user",
"no_hours_available" to "No hours available",
"confirm" to "Confirm",
"users_title" to "Users",
"search_users" to "Search users",
"assigned" to "Assigned",
"no_working_hours_available" to "No working hours available",
"update_employee" to "Update employee",
"enter_surname" to "Enter surname and name",
"phone" to "Phone",
"enter_employee_email" to "Enter employee email address",
"zip" to "Zip",
"enter_zip" to "Enter ZIP code",
"enter_street" to "Enter street name and number",
"address" to "Address",
"address_mandatory" to "Address *",
"status" to "Status",
"status_mandatory" to "Status *",
"active" to "Active",
"inactive" to "Inactive",
"skills" to "Skills",
"skill" to "Skill",
"select_skill" to "Select or create skill",
"team" to "Team",
"select_team" to "Select or create team",
"select_industry" to "Select or create industry",
"add" to "Add",
"update" to "Update",
"update_job" to "Update job",
"delete_contact" to "Delete contact",
"tap_to_upload_photo" to "Tap to upload photo",
"workspace_type" to "Workspace Type",
"employees" to "Users",
"save_new_site" to "Save new site",
"about_site" to "About site",
"all" to "All",
"teams" to "Teams",
"edit" to "Edit",
"total" to "Total",
"cancel" to "Cancel",
"delete" to "Delete",
"export_list" to "Export List",
"import_list" to "Import List",
"about_job" to "About job",
"about_this_contact" to "About this contact",
"job_title" to "Job title",
"job_title_mandatory" to "Job title *",
"title" to "Title",
"time" to "Time",
"enter_job_title" to "Enter job title",
"save_changes" to "Save changes",
"job_status" to "Job status",
"job_status_draft" to "Draft",
"job_status_open" to "Open",
"job_status_in_progress" to "In progress",
"job_status_on_hold" to "On hold",
"job_status_pending_approval" to "Pending approval",
"job_status_completed" to "Completed",
"job_status_cancelled" to "Cancelled",
"select_job_status" to "Select job status",
"assign_employee" to "Assign",
"select_employee" to "Select employee",
"select_team_or_user" to "Select team or user",
"date" to "Date",
"start_date" to "Start date",
"start_at" to "Start at",
"end_at" to "End at",
"repeat" to "Repeat",
"never" to "Never",
"due_date" to "Due date",
"job_duration" to "Job duration",
"add_steps" to "Add tasks",
"step_title" to "Task title",
"enter_step_title" to "Enter task title",
"step_description" to "Task description",
"describe_the_process" to "Describe the process",
"estimated_duration" to "Estimated Duration",
"continue_with_next_step" to "Continue with next task",
"add_step" to "Add task",
"add_notes" to "Add notes",
"files" to "Files",
"provide_information" to "Provide additional information",
"upload_documents" to "Upload documents and pictures",
"max_size" to "Max 10 MB files are allowed",
"only_support" to "Only support .jpg, .png and .pdf files",
"enter_time" to "Enter time",
"hour" to "Hour",
"minute" to "Minute",
"step" to "task",
"every_day" to "Every day",
"every_week" to "Every week",
"every_2_weeks" to "Every 2 weeks",
"every_month" to "Every month",
"custom" to "Custom",
"repeat_daily_weekday" to "Every week day",
"repeat_daily_workday" to "Every work day",
"repeat_interval" to "Interval",
"ok" to "OK",
"jobs" to "Jobs",
"job" to "Job",
"scheduler" to "Scheduler",
"contacts" to "Contacts",
"contact_deteils" to "Contact details",
"contact" to "Contact",
"places" to "Places",
"settings" to "Settings",
"logout" to "Logout",
"job_details" to "Job Details",
"about_contact" to "About contact",
"delete_site" to "Delete site",
"details" to "Details",
"steps" to "Tasks",
"site" to "Site",
"add_job" to "Add job",
"site_contact_person" to "Site & Contact person",
"company" to "Company",
"contact_name" to "Contact name",
"contact_name_mandatory" to "Contact name *",
"contact_name_and_type" to "Contact Name & Type",
"contact_site" to "Choose site",
"full_name_contact_person" to "Full Name of Contact Person",
"add_new_contact" to "Add new contact",
"contact_type" to "Contact Type",
"industry" to "Industry",
"enter_contact_name" to "Enter contact name",
"add_client" to "Add client or company contact details for task assignment.",
"expand_your_team" to "Expand your team by adding a new staff member with roles and skills.",
"plan_and_assign" to "Plan and assign a new task to your team, complete with schedules and details.",
"use_contact_name" to "Add an additional Contact Person",
"enter_email_address" to "Enter email address",
"enter_building_number" to "Enter street name and building number",
"contact_person" to "Contact person",
"employee_details" to "User details",
"enter_full_name" to "Enter full name",
"start_typing_address" to "Start typing address to see suggestions...",
"email" to "email",
"email_capital" to "Email",
"choose_team" to "Choose a team",
"add_team" to "Add team",
"create_your_first_team" to "Create your first team",
"start_by_adding" to "You haven’t created any teams yet. Start by adding one, and it will appear here. Once created, you can assign employees to this team when adding or editing their details.",
"no_tasks_yet" to "No tasks yet",
"no_tasks_text" to "No tasks have been added for this job yet. You can update the job to add tasks.",
"no_tasks_text_employee" to "No tasks have been added for this job yet. Tasks will appear once created.",
"work_schedule" to "Work Schedule",
"set_weekly_hours" to "Set Weekly Hours",
"upcoming_leaves" to "Upcoming Leaves",
"upcoming_tasks" to "Upcoming Tasks",
"upcoming_jobs" to "Upcoming Jobs",
"select_dates" to "Select dates",
"no_employees_added" to "No employees added",
"no_contacts_available" to "No contacts available",
"add_a_contact" to "Add a contact to manage jobs and keep contact details in one place.",
"add_employees" to "Your team starts here. Add employees to assign jobs and keep work organized.",
"upload_profile_picture" to "Upload profile picture",
"error" to "Error",
"error_message" to "There was an error, please try again",
"daily_activities" to "Daily Activities",
"contact_information" to "Contact information",
"employment_details" to "Employment details",
"leave_details" to "Leave details",
"all_employees" to "All Users",
"team_added" to "Team added successfully",
"team_deleted" to "Team deleted successfully",
"unselect_all" to "Unselect All",
"search" to "Search",
"name" to "Name",
"phone_number" to "Phone Number",
"city" to "City",
"clear" to "Clear",
"clear_all" to "Clear all",
"completion_report" to "Completion Report",
"task_completion_report" to "Task Completion Report",
"approve" to "Approve and Mark as Complete",
"reject" to "Reject and Send Back for Review",
"monthly" to "Monthly",
"yearly" to "Yearly - 20%",
"sort_by" to "Sort by: ",
"workspace_settings" to "Workspace settings",
"roles_permission" to "Roles & permission",
"subscription" to "Subscription",
"profile_settings" to "Profile settings",
"log_out" to "Log out",
"working_hours" to "Working hours",
"monday" to "Monday",
"tuesday" to "Tuesday",
"wednesday" to "Wednesday",
"thursday" to "Thursday",
"friday" to "Friday",
"saturday" to "Saturday",
"sunday" to "Sunday",
"zip_employee" to "Zip",
"country" to "Country",
"location_details" to "Location Details",
"location" to "Location",
"schedule" to "Schedule",
"no_worries" to "No worries, we’ve got you covered!",
"send_reset_link" to "Send reset link",
"forgot_your_password" to "Forgot your password?",
"confirm_registration" to "Confirm registration",
"reset_link_sent" to "Reset link sent!",
"set_new_password" to "Set your new password",
"new_password" to "New password",
"confirm_password" to "Confirm password",
"save_password" to "Save password",
"success" to "Success",
"about" to "About",
"sites" to "Sites",
"update_contact" to "Update contact",
"files_notes" to "Files & Notes",
"password_updated" to "Password updated! You're all set to log in with your new credentials.",
"create_strong_password" to "Create a strong password to secure your account.",
"employee_added_successfully" to "User added successfully",
"employee_updated_successfully" to "User updated successfully",
"contact_added_successfully" to "Contact added successfully",
"contact_updated_successfully" to "Contact updated successfully",
"job_added_successfully" to "Job added successfully",
"job_updated_successfully" to "Job updated successfully",
"date_error" to "Past dates cannot be selected.",
"add_new_site" to "Add new site",
"update_site" to "Update site",
"site_name" to "Site name",
"site_name_mandatory" to "Site name *",
"enter_site_name" to "Enter site name",
"add_site" to "Add site",
"add_new_button" to "Add\nnew",
"add_note_here" to "Add your note here",
"enter_text" to "Enter text",
"add_your_note_here" to "Add your note here",
"note_added_successfully" to "Note added successfully",
"note_updated_successfully" to "Note updated successfully",
"note_deleted_successfully" to "Note deleted successfully",
"file_added" to "File added successfully",
"site_added" to "Site added successfully",
"site_updated" to "Site updated successfully",
"site_deleted" to "Site deleted successfully",
"job_updated" to "Job updated successfully",
"job_added" to "Job added successfully",
"job_finished" to "Job finished successfully",
"job_deleted" to "Job deleted successfully",
"user_deleted" to "User deleted successfully",
"contact_added" to "Contact added successfully",
"contact_deleted" to "Contact deleted successfully",
"report_submitted" to "Report submitted successfully",
"job_rejected" to "Job report rejected",
"login_to_access" to "Log in to access your tasks and responsibilities",
"password_set" to "Password successfully set! You can login with your credentials.",
"try_another_document" to "Something wet wrong, try another document",
"confirm_password_reset" to "We’ve sent a reset link to your email. Please check your inbox and click the link to complete your password reset.",
"thank_you_for_registering" to "Thank you for registering! We’ve sent a confirmation link to your email. Please check your inbox and click the link to complete your registration.",
"full_name_required" to "Full Name is required.",
"phone_number_required" to "Phone number is required.",
"email_required" to "Email is required.",
"city_required" to "City is required.",
"country_required" to "Country is required.",
"address_required" to "Address is required.",
"zip_required" to "ZIP code is required",
"status_required" to "Status is required.",
"skill_required" to "A skill must be selected.",
"team_required" to "A team must be selected.",
"done_selecting_dates" to "Done",
"assigned_to" to "Assigned to: ",
"assignees" to "Assignees",
"selected" to "selected",
"start_time" to "Start Time",
"end_time" to "End Time",
"completed" to "completed",
"minutes" to "minutes",
"notes" to "Notes",
"add_file" to "Add file",
"add_note" to "Add note",
"document" to "Document",
"documents" to "Documents",
"images" to "Images",
"submit" to "Submit form",
"map" to "Map",
"notifications" to "Notifications",
"from_phone" to "Select from files",
"choose_action" to "Choose an action:",
"take_picture" to "Take a picture",
"remove_file" to "Remove file",
"upload_signature" to "Upload an image of the client's signature",
"your_comment" to "Your comment",
"comment" to "Comment",
"additional_notes" to "Add any additional notes",
"safety_requirements" to "Were all health and safety requirements met?",
"safety_requirements_title" to "Which safety requirements weren’t met?",
"safety_requirements_desc" to "Unmet safety requirements",
"yes" to "Yes",
"no" to "No",
"enter_city" to "Enter city",
"enter_country" to "Enter country",
"enter_zip_code" to "Enter ZIP code",
"no_damage" to "No damage",
"all_contacts" to "All Contacts",
"was_damage_caused" to "Was any damage caused during the work?",
"damage_title" to "What damage occurred?",
"damage_desc" to "Describe damage",
"final_inspection" to "Was a final inspection completed and confirmed that everything is functioning correctly?",
"final_inspection_fail" to "Why wasn’t the inspection completed?",
"final_inspection_desc" to "Reason for incomplete inspection",
"client_feedback" to "Client Feedback",
"feedback" to "Feedback:",
"enter_feedback" to "Enter any feedback provided by the client",
"client_signature" to "Client Signature:",
"search_to_find" to "Search to find or create team",
"add_new_job_message" to "Before adding a new job, you must first add at least one contact",
"add_new_user_message" to "Before adding a new job, you must first add at least one employee",
"add_new_site_message" to "Before adding a new job, you must first add at least one site for existing contact",
"adding_proof" to "Adding Proof of Completed Work",
"status_check" to "Status Check",
"additional_notes_report" to "Additional Notes",
"employee_comments" to "Employee Comments:",
"health_confirmation" to "Health and Safety Confirmation",
"were_safety_met" to "Were all health and safety requirements met?",
"no_completion_report" to "No completion report yet",
"report_will_appear" to "Report will appear once a job is marked as completed.",
"admin" to "Administrator",
"manager" to "Manager",
"managers" to "managers",
"employee" to "Employee",
"file_deleted" to "File deleted successfully!",
"confirmation" to "Confirmation",
"are_you_sure" to "Are you sure you want to delete?",
"are_you_sure_note" to "Are you sure you want to delete the note?",
"add_more" to "Add more",
"mark_step_completed" to "Mark task as done",
"mark_step_pending" to "Re-open task",
"complete_all_tasks_before_submitting_report" to "Please complete all tasks before submitting the report",
"you_chose" to "You chose",
"change_plan" to "Change plan",
"current_plan" to "Current plan",
"manage_subscription" to "Manage Your Subscription",
"change_or_upgrade_subscription" to "You can change or upgrade your subscription plan anytime.",
"cancel_subscription" to "Cancel Subscription",
"what_happens" to "What happens when you cancel?",
"you_will_lose" to "You will lose access to premium features after the end of the current billing cycle",
"your_data_will" to "Your data will remain saved, and you can re-subscribe anytime",
"team_members_linked" to "Team members linked to the plan may lose access to the app",
"before_you_proceed" to "Before you proceed, consider",
"downgrading_to_lower" to "Downgrading to a lower-tier plan if this one doesn’t meet your needs",
"contacting_support_for_assistance" to "Contacting support for assistance with your subscription or account",
"keep_my_subscription" to "Keep my subscription",
"continue_cancellation" to "Continue Cancellation",
"week" to "Week",
"day" to "Day",
"month_capitalized" to "Month",
"contact_type_customer" to "Customer",
"contact_type_supplier" to "Supplier",
"contact_type_contractor" to "Contractor",
"job_schedule" to "Job Schedule",
"deadline_and_duration" to "Deadline & Duration",
"duration" to "Duration",
"contact_and_site_details" to "Contact and site details",
"newest" to "Newest",
"oldest" to "Oldest",
"delete_job" to "Delete job",
"start_end_time" to "End time must be later than start time. Please select a valid time.",
"user_status_inactive" to "Inactive",
"user_status_active" to "Active",
"user_status_pending" to "Pending Confirmation",
"search_map" to "Search job",
"not_scheduled" to "Not scheduled",
"no_dates_selected" to "No dates selected",
"not_assigned" to "Not assigned",
"no_information" to "No information",
"upload_photos_of_completed_job" to "Upload photos of the completed job",
"lets_get_to_work" to "Let’s get to work!",
"plan_active_until" to "* Your current plan is active until ",
"error_manager_number" to "Please adjust the number of managers in your workspace to match the plan limits!",
"error_employee_number" to "Please adjust the number of employees in your workspace to match the plan limits!",
"nothing_to_cancel" to "You’re currently on the Free plan, so there’s nothing to cancel. Enjoy your access!",
"you_are_subscribed" to "You're subscribed! Check your inbox for updates.",
"no_plan_selected" to "No plan selected",
"unknown_error" to "An unknown error occurred",
"resend_confirmation_link" to "Click here to resend confirmation link",
"plan_downgrade_scheduled" to "A change of plan is scheduled to begin with plan ",
"no_data_received" to "No data received",
"unexpected_error" to "Unexpected error occurred",
"workspace_not_found" to "Workspace not found",
"contact_name_required" to "Contact name is required.",
"site_name_required" to "Site name is required.",
"job_title_required" to "Job title is required.",
"role_required" to "Role is required.",
"january" to "January",
"february" to "February",
"march" to "March",
"april" to "April",
"may" to "May",
"june" to "June",
"july" to "July",
"august" to "August",
"september" to "September",
"october" to "October",
"november" to "November",
"december" to "December",
"this_week" to "This week",
"members" to "Members",
"not_possible_to_buy_plan" to "At the moment, it is not possible to buy a plan.",
"unassigned" to "Unassigned",
"unnamed_team" to "Unnamed Team",
"password_length" to "Password must be at least 8 characters long",
"you_are_offline" to "You're Offline.\nPlease check your internet connection. Some features may be unavailable until you're back online.",
"no_matching_skills" to "No matching skills. Tap '+' to add.",
"no_skills_available" to "No skills available. Enter a name to create a new one.",
"no_matching_teams" to "No matching teams. Tap '+' to add.",
"no_teams_available" to "No teams available. Enter a name to create a new one.",
"no_matching_industries" to "No matching industries. Tap '+' to add.",
"no_industries_available" to "No industries available. Enter a name to create a new one.",
"passwords_do_not_match" to "Passwords do not match",
"email_format_not_valid" to "Enter a valid email address",
"files_skipped_title" to "Some files weren’t uploaded",
"files_skipped_message" to "Files larger than 10 MB cannot be uploaded.",
"job_start_time_error" to "Job start time is required.",
"job_end_time_error" to "Job end time is required.",
"task_title_error" to "Task title is required.",
"note_empty" to "You can add notes here to keep track of important information related to this process. Click the 'Add note' button to create a new entry. All added notes will appear here.",
"file_empty" to "You can upload files in various formats, including .png, .pdf, and others. Simply click the ‘Add file’ button to start the upload process. Once uploaded, files will appear here.",
"task_empty" to "You can add tasks here to keep track of actions related to this process. Click the 'Add task' button to create a new entry. All added tasks will appear here.",
"filter_empty" to "There is nothing to filter"
            )
        }